import React from 'react';
/*import { Link } from 'react-router-dom';*/
import '../styles/Securedassets.css';

const SecuredAssets = () => {
  return (
    <>
      {/* ── HERO ─────────────────────────────────────────── */}
      <section className="sap-hero">
        <div className="sap-hero-inner">
          <nav className="sap-breadcrumb" aria-label="Breadcrumb">

          </nav>
          <h1>Secured Assets Possessed</h1>
          <div className="sap-hero-tag">
            <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            Under SARFAESI Act, 2002 &nbsp;·&nbsp; RBI Circular 25 Sep 2023
          </div>
        </div>
      </section>

      {/* ── MAIN ─────────────────────────────────────────── */}
      <main className="sap-main">

        {/* RBI Notice */}
        <div className="sap-notice">
          <div className="sap-notice-label">RBI Mandate — Transparency Disclosure</div>
          <p>
            Information in respect of borrowers whose secured assets have been taken into possession
            by the Bank under the SARFAESI Act, 2002 is required to be displayed as per{' '}
            <strong>Reserve Bank of India circular dated 25th September 2023.</strong>
          </p>
        </div>

        {/* Info Cards */}
        <div className="sap-section-head">
          <h2>About This Disclosure</h2>
          <div className="sap-rule"></div>
        </div>
        <div className="sap-cards">
          <div className="sap-card">
            <div className="sap-card-ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="#27a3d7" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 21V9" />
              </svg>
            </div>
            <h3>What is SARFAESI Act?</h3>
            <p>The Securitisation and Reconstruction of Financial Assets and Enforcement of Security Interest Act, 2002 enables banks to recover NPAs without court intervention.</p>
          </div>

          <div className="sap-card">
            <div className="sap-card-ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="#27a3d7" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14,2 14,8 20,8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
              </svg>
            </div>
            <h3>RBI Circular Compliance</h3>
            <p>As mandated, Regulated Entities must publicly display possession details of secured assets on their official website for greater transparency.</p>
          </div>

          <div className="sap-card">
            <div className="sap-card-ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="#27a3d7" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
            <h3>Legal Framework</h3>
            <p>Possession is carried out under Sections 13(2) and 13(4) of the SARFAESI Act, 2002, after serving appropriate statutory notices to borrowers.</p>
          </div>

          <div className="sap-card">
            <div className="sap-card-ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="#27a3d7" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <h3>Borrower Rights</h3>
            <p>Borrowers may appeal before the Debt Recovery Tribunal (DRT) under Section 17 of the SARFAESI Act within 45 days of possession of secured assets.</p>
          </div>
        </div>

        {/* RBI Quote */}
        <div className="sap-quote">
          <div className="sap-quote-tag">&#x275D; RBI Official Statement</div>
          <p>
            "As a part of the move towards greater transparency, it has been decided that the Regulated Entities (REs)
            of the Reserve Bank which are secured creditors as per the Securitisation and Reconstruction of Financial
            Assets and Enforcement of Security Interest (SARFAESI) Act, 2002, shall display information in respect of
            the borrowers whose secured assets have been taken into possession by the REs under the Act."
            {' '}<strong>— Reserve Bank of India, Circular dated 25th September 2023.</strong>
          </p>
        </div>

        {/* Download Block */}
        <div className="sap-section-head">
          <h2>Possessed Assets Register</h2>
          <div className="sap-rule"></div>
        </div>
        <div className="sap-download-block">
          <div>
            <h3>Download Possession Register</h3>
            <p>
              The complete list of borrowers whose secured assets have been taken into possession
              by The Sahyadri Sahakari Bank Ltd is available for download, as per
              RBI Circular dated 25th September 2023.
            </p>
          </div>
          <div className="sap-download-btns">
            <a
              href="./forms/possessed-assets-register.pdf"
              className="sap-btn sap-btn-white"
              download
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7,10 12,15 17,10" /><line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Download PDF
            </a>
          </div>
        </div>

      </main>
    </>
  );
};

export default SecuredAssets;